import { endsWith, chain } from "lodash"
import { useEffect, useState } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import PropTypes from "prop-types"
import { PhotoSizeSelectActual } from "@mui/icons-material"
import useMountEffect from "hooks/mount-effect"
import SearchableMenu from "components/searchable-menu"
import ShareMyView from "modules/share-my-view"
import withOutletContext from "hocs/withOutletContext"
import { useRouterPath } from "hooks/router"
import ModelWrapper from "connected-components/model-wrapper"
import "./style.scss"

const MarketTools = ({
  setHeader,
  selectScreen,
  modelId,
  modelName,
  setModel,
  setHomeLayoutModel,
  isModelInQueryString,
  isOpPro,
}) => {
  const navigate = useNavigate()
  useMountEffect(() => {
    if (endsWith(window.location.pathname, "factors/risk") && isOpPro) {
      navigate("../factors/performance")
    }
  })

  const path = useRouterPath()
  const selectedScreen = chain(path.path)
    .split("/")
    .nth(4)
    .value()

  const [shareMyViewProps, setShareMyViewProps] = useState({})

  useEffect(() => {
    // update the home selected model to match the one provided to market tools
    // this will happen at most once on initial load, and every time the selected model is changed
    setHomeLayoutModel(modelId)
  }, [setHomeLayoutModel, modelId])

  useEffect(() => {
    // update the model selector manually since components in the header don't automatically get updated/re-rendered when props change
    setHeader(MarketTools.getHeaderConfig({
      selectScreen,
      selectedScreen,
      shareMyViewProps,
    }))
  }, [selectScreen, selectedScreen, setHeader, shareMyViewProps])

  useEffect(() => {
    if (!isModelInQueryString) {
      setModel(modelId)
    }
  }, [isModelInQueryString, setModel, modelId])

  return <div className="modules_market-tools">
    <ModelWrapper {...{ modelId, modelName, setModel }}>
      <Outlet context={{ modelId, setShareMyViewProps }} />
    </ModelWrapper>
  </div>
}

MarketTools.propTypes = {
  selectScreen: PropTypes.func.isRequired,
  modelId: PropTypes.string.isRequired,
  modelName: PropTypes.string,
  setModel: PropTypes.func.isRequired,
  setHeader: PropTypes.func.isRequired,
  setHomeLayoutModel: PropTypes.func.isRequired,
  isModelInQueryString: PropTypes.bool.isRequired,
  isOpPro: PropTypes.bool.isRequired,
}

MarketTools.getHeaderConfig = ({
  selectScreen,
  selectedScreen,
  shareMyViewProps,
}) => ({
  icon: PhotoSizeSelectActual,
  title: "Market",
  key: "market-tools",
  noShadow: true,
  topnav: <SearchableMenu
    items={[{
      order: 0,
      id: "factors",
      label: "Factors Leaderboard",
    }, {
      order: 1,
      id: "securities",
      label: "Securities",
    }]}
    current={selectedScreen}
    onSelect={selectScreen}
    hideSearchBox
    className="market-tools-screens"
  />,
  actions: { rightActions: [<ShareMyView key="share-my-view" {...shareMyViewProps} />] },
})

export default withOutletContext(MarketTools)
